@if (Globals.domainInfo?.splash) {
  <div class="splash">
    <img [src]="Globals.domainInfo.splash"  alt="" />
  </div>
}

<div class="form-wrapper">
  <div class="register-wrapper">
    @if (form) {
      <div class="register-options card-like">
        <h1 class="title">{{ 'loginto' | translate:{value: Globals.domainInfo?.name || Globals.APP_NAME } }}</h1>
        <div class="social">
<!--          <button nbButton size="large" (click)="socialLogin('linkedin')" class="social-button linkedin">-->
<!--            <nb-icon icon="linkedin"></nb-icon><span>{{ 'loginwithlinkedin' | translate }}</span>-->
<!--          </button>-->
<!--          <div class="sep">-->
<!--            <span>{{ 'or' | translate }}</span>-->
<!--          </div>-->
          <button nbButton size="large" (click)="socialLogin('google')" class="social-button google">
            <nb-icon pack="custom-icons" icon="google"></nb-icon><span>{{ 'loginwithgoogle' | translate }}</span>
          </button>
          <div class="terms">
            {{ 'terms.1' | translate }}
            <a href="assets/files/flix_it_terms_of_service.pdf" target="_blank">{{ 'termsconditions' | translate }}</a>
            {{ 'terms.2' | translate }}
            <a href="assets/files/flix_it_privacy_policy.pdf" target="_blank">{{ 'privacypolicy' | translate }}</a>{{ 'terms.3' | translate }}
          </div>
          <div class="sep">
            <span>{{ 'or' | translate }}</span>
          </div>
          <div>
            <h3>{{ 'loginwithusername' | translate }}</h3>
            <form [formGroup]="form">
              <div class="inputs">
                <div class="input-group">
                  <div>
                    <label for="login-email">{{ 'email' | translate }}</label>
                    <input id="login-email" nbInput fullWidth type="email" autocomplete="username" formControlName="username" [placeholder]="'enterusername' | translate">
                  </div>
                </div>
                <div class="input-group">
                  <div>
                    <label for="login-password">{{ 'password' | translate }}</label>
                    <input id="login-password" nbInput fullWidth type="password" autocomplete="current-password" formControlName="password" [placeholder]="'enterpassword' | translate" [autofocus]="email != null">
                  </div>
                </div>
              </div>
              <div class="buttons">
                <a [routerLink]="'./'" queryParamsHandling="merge" [queryParams]="{state: 'forgot', email:form.getRawValue().username}">{{ 'forgotpassword' | translate }}</a>
                <button nbButton type="submit" status="primary" [bstErroring]="form" (bstErroringSuccess)="submit()"><span>{{ 'login' | translate }}</span><nb-icon icon="arrow-right"></nb-icon></button>
              </div>
            </form>
          </div>
        </div>
      </div>
    }
    @if (reset) {
      <div class="register-options card-like">
        <h3>{{ 'resetpassword' | translate }}</h3>
        <form [formGroup]="reset">
          <div class="inputs">
            <input type="hidden" formControlName="email">
            <input type="hidden" formControlName="token">
            <input type="hidden" formControlName="key">
            <bst-password formControlName="password" [fullWidth]="true" [placeholder]="'enternewpassword' | translate"></bst-password>
          </div>
          <div class="buttons">
            <button nbButton type="button" status="primary" [bstErroring]="reset" (bstErroringSuccess)="submitReset()">{{ 'setpassword' | translate }}</button>
          </div>
        </form>
      </div>
    }
    @if (forgot) {
      <div class="register-options card-like">
        <h3>{{ 'resetpassword' | translate }}</h3>
        <form [formGroup]="forgot">
          <label>
            {{ 'resetinfo' | translate }}
          </label>
          <br>
            <div class="inputs">
              <div class="input-group">
                <div>
                  <label for="recovery-email">{{ 'email' | translate }}</label>
                  <input id="recovery-email" autofocus nbInput fullWidth formControlName="email" type="email" autocomplete="email" [placeholder]="'enterusername' | translate">
                </div>
              </div>
            </div>
            <div class="buttons">
              <button nbButton type="button" [routerLink]="'/login'">
                <nb-icon icon="arrow-left"></nb-icon>
                <span>{{ 'back' | translate }}</span>
              </button>
              <button nbButton type="button" status="primary" [bstErroring]="forgot" (bstErroringSuccess)="submitForgot()">
                {{ 'setpassword' | translate }}
              </button>
            </div>
          </form>
        </div>
      }
      <div class="already">
        <a [routerLink]="'/register'" [queryParams]="{with: this.id}">{{ 'noregistered' | translate }}</a>
      </div>
    </div>
  </div>
